import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    threshold: { type: Number, default: 50 } // Scroll threshold in pixels
  }

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    this.handleAnchorClicks = this.handleAnchorClicks.bind(this)
    this.isCompact = false
    // Hysteresis buffer to prevent jitter when near threshold
    this.hysteresis = 30

    window.addEventListener('scroll', this.handleScroll, { passive: true })
    document.addEventListener('click', this.handleAnchorClicks)
    this.handleScroll() // Check initial state
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.handleAnchorClicks)
  }

  handleScroll() {
    const scrollY = window.scrollY || window.pageYOffset

    // Use hysteresis to prevent jitter: different thresholds for compact on vs off
    if (!this.isCompact && scrollY > this.thresholdValue) {
      this.isCompact = true
      this.element.classList.add('compact')
    } else if (this.isCompact && scrollY < this.thresholdValue - this.hysteresis) {
      this.isCompact = false
      this.element.classList.remove('compact')
    }
  }

  handleAnchorClicks(event) {
    const target = event.target.closest('a[href^="#"]')
    if (!target) return

    const href = target.getAttribute('href')
    if (!href || href === '#') return

    const targetElement = document.querySelector(href)
    if (!targetElement) return

    event.preventDefault()

    // Calculate offset for sticky header (topbar + sticky header + some padding)
    const topbarHeight = 70 // Main topbar
    const stickyHeaderHeight = this.element.offsetHeight
    const offset = topbarHeight + stickyHeaderHeight + 20 // Extra 20px padding

    const elementPosition = targetElement.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }
}
